import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BusinessPublicInfo } from '../../../../shared/interfaces';

@Component({
  selector: 'app-microsite-actions-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './microsite-actions-bar.html',
  styleUrl: './microsite-actions-bar.css',
})
export class MicrositeActionsBarComponent {
  @Input() business: BusinessPublicInfo | null = null;
  @Input() onBookClick: () => void = () => {};

  getGoogleMapsUrl(): string {
    const address = this.business?.address;
    if (!address) return '#';
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  }

  getWhatsAppUrl(): string {
    const whatsapp = this.business?.whatsApp;
    if (!whatsapp) return '#';
    const cleaned = whatsapp.replace(/[\s\-\(\)]+/g, '');
    const message = encodeURIComponent(
      `Hola, me gustaría obtener más información sobre ${this.business?.name || 'sus servicios'}.`
    );
    return `https://wa.me/${cleaned}?text=${message}`;
  }

  hasWhatsApp(): boolean {
    return !!this.business?.whatsApp;
  }

  hasPhone(): boolean {
    return !!this.business?.phone;
  }

  getPhoneUrl(): string {
    const phone = this.business?.phone;
    if (!phone) return '#';
    const cleaned = phone.replace(/[\s\-\(\)]+/g, '');
    return `tel:${cleaned}`;
  }

  hasSecondaryActions(): boolean {
    return this.hasWhatsApp() || this.hasPhone() || !!this.business?.address;
  }

  secondaryActionCount(): number {
    return (this.hasWhatsApp() ? 1 : 0) + (this.hasPhone() ? 1 : 0) + (this.business?.address ? 1 : 0);
  }

  handleBookClick(): void {
    this.onBookClick();
  }
}
